<!--
* @Component: ToolbarNotifications
* @Maintainer: J.K. Yang
* @Description:
-->
<script setup lang="ts">
import { useAuthStore } from "~/src/stores/auth.store";

const authStore = useAuthStore();
const user = ref(authStore.user);

const avatarUrl = computed<string>(
  () => {
    // If avatar_url is available from backend, use it
    if (user.value?.avatar_url) {
      return user.value.avatar_url;
    }

    // Otherwise generate avatar using UI Avatars
    const url = new URL('/api', 'https://ui-avatars.com');
    if (user.value?.display_name)
      url.searchParams.set('name', user.value?.display_name);

    url.searchParams.set('background', '0D8ABC');
    url.searchParams.set('color', 'fff');

    return url.toString();
  }
)

const handleLogout = async () => {
  await authStore.logout();
  // console.log("---");
  // console.log(router);
};

// const navs = [
//   {
//     title: "Profile Details",
//     key: "menu.profileDetails",
//     link: "/profile",
//     icon: "mdi-account-box-outline",
//   },
// ];
</script>

<template>
  <v-menu :close-on-content-click="false" location="bottom right" transition="slide-y-transition">
    <!-- ---------------------------------------------- -->
    <!-- Activator Btn -->
    <!-- ---------------------------------------------- -->
    <template v-slot:activator="{ props }">
      <v-btn class="mx-2" icon v-bind="props">
        <v-badge content="2" color="success" dot bordered>
          <v-avatar size="40">
            <v-img :src="avatarUrl"></v-img>
          </v-avatar>
        </v-badge>
      </v-btn>
    </template>
    <v-card max-width="300">
      <v-list lines="three" density="compact">
        <!-- ---------------------------------------------- -->
        <!-- Profile Area -->
        <!-- ---------------------------------------------- -->
        <v-list-item>
          <template v-slot:prepend>
            <v-avatar size="40">
              <v-img :src="avatarUrl"></v-img>
            </v-avatar>
          </template>

          <v-list-item-title class="font-weight-bold text-primary">
            {{ user?.display_name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            <!-- {{ $store.state.user.email  }} -->
            {{ user?.email }}
          </v-list-item-subtitle>
        </v-list-item>
      </v-list>
      <v-divider />
      <!-- ---------------------------------------------- -->
      <!-- Menu Area -->
      <!-- ---------------------------------------------- -->
      <v-list variant="flat" elevation="0" :lines="false" density="compact">
        <v-list-item color="primary" :to="{ name: 'auth-my-account' }" link density="compact">
          <template v-slot:prepend>
            <v-avatar size="30">
              <v-icon>mdi-account-cog</v-icon>
            </v-avatar>
          </template>

          <div>
            <v-list-item-subtitle class="text-body-2">
              {{ $t('myAccount.title') }}
            </v-list-item-subtitle>
          </div>
        </v-list-item>
      </v-list>
      <v-divider />

      <!-- ---------------------------------------------- -->
      <!-- Logout Area -->
      <!-- ---------------------------------------------- -->
      <v-list variant="flat" elevation="0" :lines="false" density="compact">
        <!-- <v-list-item color="primary" to="nav.link" link density="compact">
          <template v-slot:prepend>
            <v-avatar size="30">
              <v-icon>mdi-lifebuoy</v-icon>
            </v-avatar>
          </template>

          <div>
            <v-list-item-subtitle class="text-body-2">
              Help Center
            </v-list-item-subtitle>
          </div>
        </v-list-item> -->
        <v-list-item color="primary" link @click="handleLogout" density="compact">
          <template v-slot:prepend>
            <v-avatar size="30">
              <v-icon>mdi-logout</v-icon>
            </v-avatar>
          </template>

          <div>
            <v-list-item-subtitle class="text-body-2">
              Logout
            </v-list-item-subtitle>
          </div>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<style scoped lang="scss">
// ::v-deep .v-list-item__append,
// ::v-deep .v-list-item__prepend {
//   height: 100%;
// }
</style>
